"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnAction = exports.setOnAction = void 0;
const src_1 = require("..");
function setOnAction(onAction) {
    src_1.expressPayContext.onAction = onAction;
}
exports.setOnAction = setOnAction;
function getOnAction() {
    return src_1.expressPayContext.onAction;
}
exports.getOnAction = getOnAction;
